import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BecareService } from 'src/app/services/becare.service';

@Component({
  selector: 'app-jobstatus',
  templateUrl: './jobstatus.component.html',
  styleUrls: ['./jobstatus.component.scss']
})
export class JobstatusComponent implements OnInit, OnDestroy {

  private subs: Subscription;
  private interval;
  private status;

  public show = false;
  public count = 0;
  public index = 0;
  public percentage = 0;

  constructor(private becare: BecareService) { }

  ngOnInit(): void {
    this.interval = setInterval(() => {
      // Check job staus
      this.subs = this.becare.call('/fr/jobs/status').subscribe(result => {
        console.log(result);
        if (typeof result.success !== 'undefined' && result.success === true) {
          this.status = result.status;
          if (!Array.isArray(this.status)) {
            this.show = true;
            const firstStatus = this.status[Object.keys(this.status)[0]];
            this.index = parseFloat(firstStatus.processingindex) + 1;
            this.count = parseFloat(firstStatus.count);
            this.percentage = Math.floor((this.index / this.count) * 100);
          } else {
            this.show = false;
          }
        }
      });
    }, 5000);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }
}
